/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const schedulePageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const schedulePageResponseOutputItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const schedulePageResponseOutputItemsItemTimeZoneMax = 100;

export const schedulePageResponseOutputItemsItemVersionExclusiveMin = 0;
export const schedulePageResponseOutputItemsItemVersionMax = 9007199254740991;

export const schedulePageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const schedulePageResponseOutputItemsItemArchivedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const schedulePageResponseOutputItemsMax = 100;

export const schedulePageResponseOutputNextCursorOneMax = 512;

export const schedulePageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const SchedulePageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(schedulePageResponseOutputItemsItemIdRegExp),
        teamId: zod.uuid().regex(schedulePageResponseOutputItemsItemTeamIdRegExp),
        name: zod.unknown().and(zod.unknown()),
        timeZone: zod.string().min(1).max(schedulePageResponseOutputItemsItemTimeZoneMax),
        state: zod.enum(['active', 'archived']),
        version: zod
          .int()
          .gt(schedulePageResponseOutputItemsItemVersionExclusiveMin)
          .max(schedulePageResponseOutputItemsItemVersionMax),
        createdAt: zod.iso
          .datetime({ offset: true })
          .regex(schedulePageResponseOutputItemsItemCreatedAtRegExp),
        archivedAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(schedulePageResponseOutputItemsItemArchivedAtOneRegExp),
          zod.null(),
        ]),
      }),
    )
    .max(schedulePageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(schedulePageResponseOutputNextCursorOneMax)
      .regex(schedulePageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type SchedulePageResponseOutput = zod.input<typeof SchedulePageResponseOutput>;
export type SchedulePageResponseOutputOutput = zod.output<typeof SchedulePageResponseOutput>;
